import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import { connect } from "react-redux";
import PropTypes from "prop-types"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Location } from '@reach/router';

class EmojiNav extends React.PureComponent {
  render() {
    const {hideNav, breadcrumbs, navContext} = this.props;
    const lang_code = navContext.code;
    const link_prepend = lang_code !== "en" ? `/${lang_code}/` : `/`;
    const base_emoji_path = navContext.emojiPath.string ? `${link_prepend}${navContext.emojiPath.string}/` : null;
    return <div className="section">
      <p><Link to={base_emoji_path} activeClassName="active" onClick={hideNav}>
        {navContext.emojiHeader.string}
      </Link></p>
      {navContext.emojiCategories.map(emoji => {
        const emoji_path = `/${emoji.path}/`;
        const is_active = breadcrumbs.find((b) => {
          return b.link === emoji_path
        });
        return (<Link
          className={is_active?"active":null}
          activeClassName="active"
          key={emoji.path}
          to={emoji_path}
          onClick={hideNav}>
          {emoji.navName}
          </Link>)
      })}
    </div>
  }
}

class Nav extends React.PureComponent {
  componentDidMount() {
    this.props.hideNav(); // if window <= 600
  }
  getNavClass() {
    let navOn = this.props.navOn;
    if (navOn === null) {
      return 'navInit';
    } else if (navOn) {
      return 'navOn';
    } else {
      return 'navOff';
    }
  }
  render(){
    const {isDocked, translatedLinks, toggleNav, hideNav, navContext} = this.props;
    const lang_code = navContext.code;
    const link_prepend = lang_code !== "en" ? `/${lang_code}/` : `/`;
    const howto_path = `${link_prepend}${navContext.howToPath.string}/`;
    const style_path = `${link_prepend}${navContext.stylePath.string}/`;
    const emoji_path = `${link_prepend}${navContext.emojiPath.string}/`;

    return (<Wrapper
      isDocked={isDocked}
      className={`nav ${this.getNavClass()}`}
      >
      <Location>
        {({ location }) => {
          const path_array = location.pathname.split('/').filter(Boolean);
          let is_emoji_page = false;
          if (path_array.length && path_array[0] === "emoji") {
            is_emoji_page = true;
          }
          return <div className="nav_inner">
            {
              <span 
                className="toggle_nav" 
                onClick={toggleNav}
                onKeyPress={toggleNav}
                tabIndex={0}
                role={`button`}
              >
                <FontAwesomeIcon icon="bars" width="12"/>
              </span>
            }

            <Link activeClassName="active" className="section" to={link_prepend || "/"} onClick={hideNav}>
              {navContext.homeHeader.string}
            </Link>
            
            {
              is_emoji_page && emoji_path && <EmojiNav {...this.props} location={location} />
            }

            <div className="section">
              <p><Link to={style_path} activeClassName="active" onClick={hideNav}>
                {navContext.stylesHeader.string}
              </Link></p>
              {navContext.textStyles.map(style => {
                return (<Link
                  activeClassName="active"
                  key={style.path}
                  to={`/${style.path}/`}
                  onClick={hideNav}>
                  {style.shortTitle}
                  </Link>)
              })}
            </div>
            
            {
              !is_emoji_page && emoji_path && <EmojiNav {...this.props} location={location} />
            }
            
            {
              navContext.blogArticles.length && <div className="section">
                  <p><Link to="/blog/" activeClassName="active" onClick={hideNav}>
                    Blog
                  </Link></p>
                  {navContext.blogArticles.sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)).map(blog => {
                    return (<Link
                      activeClassName="active"
                      key={blog.path}
                      to={`/${blog.path}/`}
                      onClick={hideNav}>
                        <strong>{blog.publishedAt}</strong> {blog.title}
                      </Link>)
                  })}
                </div>
            }

            <div className="section">
              <p><Link to={howto_path} activeClassName="active" onClick={hideNav}>
                {navContext.howToHeader.string}
              </Link></p>
              {navContext.howToArticles.map(howto => {
                return (<Link
                  activeClassName="active"
                  key={howto.path}
                  to={`/${howto.path}/`}
                  onClick={hideNav}>
                  {howto.tinyTitle}
                  </Link>)
              })}
            </div>

            <div className="section">
              <p><Link to={`${link_prepend}faq/`} activeClassName="active" onClick={hideNav}>
                {navContext.faqHeader.string}
              </Link></p>
              {navContext.faqArticles.map(faq => {
                return (<Link
                  key={faq.slug}
                  to={`${link_prepend}faq/#${faq.slug}`}
                  onClick={hideNav}>
                  {faq.sidebarTitle}
                  </Link>
                )
              })}
              <Link className="faq_more" to={`${link_prepend}faq/`} onClick={hideNav}>
                {navContext.readMore.string}
              </Link>
            </div>
            <div className="section">
              <a href={`https://smileyfaces.io/`}>
                smileyfaces.io ㋛ ꗸ
              </a>
            </div>
            <div className="section">
              <div className="social_button">
                <div className="fb-like" data-href="https://facebook.com/yaytext" data-layout="button" data-action="like" data-size="large" data-show-faces="false" data-share="false"></div>
              </div>
              <div className="social_button">
                <a className="twitter-follow-button" href="https://twitter.com/yaytext" data-show-screen-name="false" data-size="large" data-show-count="false" lang={navContext.twitter_code}>Follow @YayText</a>
              </div>
            </div>

            {
              translatedLinks.length > 0
              && <div className="section language">
                    <p>{navContext.languageHeader.string}</p>
                    {(translatedLinks || []).sort((a, b) => {
                      if (a.code === 'en' || a.code < b.code) {
                        return -1;
                      } else if (a.code > b.code) {
                        return 1;
                      }
                      return 0;
                    }).filter((t) => {
                      return t.code !== lang_code
                    }).map((l, i) => {
                      return (<div key={`lang_link_${i}`} className="link"><div className="inner_link">
                        <Link to={l.link} lang={l.code} hrefLang={l.code} onClick={hideNav}>
                          {l.nativeName}
                        </Link>
                      </div></div>)
                    })}
                  </div>
            }

          </div>
        }}
      </Location>
    </Wrapper>)
  }
}

const Wrapper = styled("div")`
  position: fixed;
  left: 0;
  top: 0;
  background: linear-gradient(to right, rgba(170, 217, 223, 1) , rgba(170, 217, 223, 0.25));
  width: 130px;
  z-index: 1000;
  font-size: 12px;
  line-height: 1.2;
  height: ${props => { return props.isDocked ? 'calc(100% - 36px)' : '100%' }};
  margin-top: ${props => { return props.isDocked ? '36px' : '0'}};
  border-right: 1px solid rgba(0, 0, 0, 0.3);
  @media screen and (max-width: 600px) {
    background: linear-gradient(to right, rgba(170, 217, 223, 1) , rgba(170, 217, 223, 0.8));
  }
  &.navInit {
    display: block;
    @media screen and (max-width: 600px) {
      display: none;
    }
  }
  &.navOff {
    display: none;
  }
  &.navOn {
    display: block;
  }
  .toggle_nav {
    display: none;
    margin-right: 1em;
    @media screen and (max-width: 600px) {
      display: ${props => { return props.isDocked ? 'none' : 'inline' }};
    }
  }
  .nav_inner {
    padding:10px;
    overflow-y: scroll;
    height: 100%;
    box-sizing: border-box;
    @media screen and (max-width: 600px) {
      padding: 5px
    }
  }
  .section {margin: 0 0 10px;}
  div.section {
    float: left;
    clear: left;
    width: 100%;
    p {
      border-bottom: 1px solid #333;
      font-weight: bold;
      margin: 0 0 6px 0;
    }
    p a {
      text-decoration: none;
      color: inherit;
      border: 0;
      margin: 0;
  	}
  }
  a { display:block; color: #000; padding: 2px 0; border-bottom: 1px solid #00000025; text-decoration: none; width: 100%;}
  a.section {font-weight: bold; margin: 0 0 5px 0; }
  a:hover { background: white; }
  .social_button { margin: 0 0 4px }
  a.faq_more {
  	font-weight: normal;
  	text-align: right;
  	font-size: .8em;
  	border: 0;
  	color: #333;
  }
  .section.language div.link {
  	width: 50%;
  	float: left;
  	line-height: 2.2em;
  	height: 2.2em;
    .inner_link {
    	display: inline-block;
    	vertical-align: middle;
    	line-height: 1;
    }
    a {
    	border: 0;
    	font-weight: normal;
    }
  }
  .active {
    border-bottom-color: #00000075;
    background: #00000012;
  }
`

export default connect(state => ({
  navOn : state.navOn,
  isDocked: state.isDocked,
  screenWidth: state.screenWidth
}), dispatch => {
  return {
    hideNav: () => dispatch({ type: `HIDE_NAV` }),
    toggleNav: () => dispatch({ type: `TOGGLE_NAV` }),
	}
})(Nav);

Nav.propTypes = {
  language: PropTypes.shape({
    code: PropTypes.string.isRequired,
    twitter_code: PropTypes.string.isRequired
  }),
  nav: PropTypes.shape({
    sections: PropTypes.array.isRequired
  })
}
